<template>
  <b-modal id="modal-2">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>
          <i
            class="fa fa-2x fa-orange fa-exclamation-triangle mb-3 slow-spin animated"
          ></i>
        </div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <div style="float: left;">
        <p>
          Are you sure you want to delete this
          <slot name="entityType" />?
        </p>
        <span class="heading lead" style="text-align: left;">
          <slot name="header"></slot>
        </span>
        <span class="heading lead" style="text-align: left;">
          <slot name="details"></slot>
        </span>
      </div>
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-2')"
          aria-label="Close"
          >Cancel</b-button
        >
        <a
          type="button"
          class="btn btn-primary text-white"
          @click="DeleteConfirmed"
        >
          Yes, I'm sure
          <i class="fa fa-trash ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["n_user"]),
    ...mapActions("n_user", ["Delete"]),
    ...mapActions("dealership", ["Delete"]),
    ...mapActions("campaign", ["Delete"])
  },
  methods: {
    DeleteConfirmed() {
      var _command = "";
      switch (this.EntityType) {
        case "Client":
          _command = "client/Delete";
          break;
        case "Dealership":
          _command = "dealership/Delete";

          break;
        case "Campaign":
          _command = "campaign/Delete";
          break;
        case "Restaurant":
          _command = "seminar/DeleteRestaurant";
          break;
        case "Cuisine":
          _command = "seminar/DeleteCuisine";
          break;
        case "Artwork":
          _command = "seminar/DeleteArtwork";
          break;
        case "Vendor":
          _command = "seminar/DeleteVendor";
          break;
        case "Contact":
          _command = "seminar/DeleteContact";
          break;
        case "TerritoryContact":
          _command = "seminar/DeleteTerritoryContact";
          break;
        case "Seminar":
          _command = "seminar/DeleteSeminar";
          break;
        case "Territory":
          _command = "territory/DeleteTerritory";
          break;
        case "LPFilter":
          _command = "lpfilter/DeleteLPFilter";
          break;
        case "N_User":
          _command = "n_user/Delete";
      }
      this.$store.dispatch(_command, this.CurrentObject).then(response => {
        this.$bvModal.hide("modal-2");
        this.$emit("filterList");
      });
    }
  },
  props: {
    CurrentObject: Object,
    EntityType: ""
  },
  updated() {}
};
</script>
